import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export interface DateFieldOption {
  name: string;
  caption: string;
}

interface Props {
  selectedDateField: string | undefined;
  onSelectedDateFieldChange: (dateField: string) => void;
  dateFields: DateFieldOption[];
  readonly: boolean;
}

const DateToShowSelect = ({ selectedDateField, onSelectedDateFieldChange, dateFields, readonly }: Props) => {
  return (
    <FormControl>
      <InputLabel id="date-to-show-label">Date to show</InputLabel>
      <Select
        labelId="date-to-show-label"
        label="Date to show"
        value={selectedDateField ?? ""}
        onChange={(evt) => onSelectedDateFieldChange(evt.target.value)}
        disabled={readonly}
      >
        {dateFields.map((field) => (
          <MenuItem key={field.name} value={field.name}>
            {field.caption}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DateToShowSelect;
